import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-primary mb-4">404</h1>
        <p className="text-xl text-muted-foreground mb-8">Page not found</p>
        <Link to="/dashboard" className="px-6 py-3 bg-primary text-primary-foreground rounded-lg">
          Go to Dashboard
        </Link>
      </div>
    </div>
  );
}
